<p-dialog header="Leads Detalhe" [(visible)]="visible" [style]="{width: '88%', left: '91px'}" (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <p-tabView>
      <p-tabPanel header="Informações">
        <p-panel header="Cliente" [toggleable]="true">
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.nomeLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadNome}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.sobrenomeLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadSobrenome}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.emailLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadEmail}} </h6>
            </div>
          </div>
          <br>
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.telefoneLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadTelefone | telefone}}</h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.temperaturaLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadTemperatura}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.origem'}} </small>
              <h6 class="font-size-information">{{leadGrid.origemLead}} </h6>
            </div>
          </div>
          <br>
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.modeloLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadModelo}} </h6>
            </div>
            <div class="col-8">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.cliente.versaoLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadVersao}} </h6>
            </div>
          </div>
        </p-panel>
        <br>
        <p-panel header="Informações" [toggleable]="true">
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.informacoes.codConcessionaria'}} </small>
              <h6 class="font-size-information">{{leadGrid.codConcessionaria}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.informacoes.concessionaria'}} </small>
              <h6 class="font-size-information">{{leadGrid.concessionaria}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.informacoes.idFabrica'}} </small>
              <h6 class="font-size-information">{{leadGrid.idFabrica}} </h6>
            </div>
          </div>
          <br>
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.informacoes.codigoEventoLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.codigoEventoLead}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.informacoes.dtHoraLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadDataHora}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.informacoes.descTipoEvento'}} </small>
              <h6 class="font-size-information">{{leadGrid.descTipoEvento}} </h6>
            </div>            
          </div>
        </p-panel>
      </p-tabPanel>
      <p-tabPanel header="Histórico">
        <p-panel header="Resultado" [toggleable]="true">
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.statusLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadStatus}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.gerenteLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadGerente}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.vendedorLead'}} </small>
              <h6 class="font-size-information">{{leadGrid.leadVendedor}} </h6>
            </div>
          </div>
          <br>
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.numeroProposta'}} </small>
              <h6 class="font-size-information">{{leadGrid.propostaNum}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.statusProposta'}} </small>
              <h6 class="font-size-information">{{leadGrid.statusProposta}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.valorVendaProposta'}} </small>
              <h6 class="font-size-information">{{leadGrid.valorVenda | real}} </h6>
            </div>
          </div>
          <br>
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.dataNF'}} </small>
              <h6 class="font-size-information">{{leadGrid.dataNF}} </h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.numeroNF'}} </small>
              <h6 class="font-size-information">{{leadGrid.numeroNF}} </h6>
            </div>
            <div class="col-4" *ngIf="leadGrid.motivoInsucesso != ''">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.motivoInsucesso'}} </small>
              <h6 class="font-size-information">{{leadGrid.motivoInsucesso}} </h6>
            </div>
          </div>
          <br>
          <div class="row alinhamento-row">
            <div class="col-4" *ngIf="leadGrid.dataHoraInsucesso != null">
              <small translate class="stats-label head-item"> {{'relatorioVeiculos.leads.detalhes.resultado.dtHoraInsucesso'}} </small>
              <h6 class="font-size-information">{{leadGrid.dataHoraInsucesso}} </h6>
            </div>          
          </div>
        </p-panel>
        <br>
        <p-panel header="Usado na Troca" [toggleable]="true">
          <div class="card">
            <p-table #dt2 [columns]="colsUsado" [value]="dadosUsadoNaTroca" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10,20,30,50,100]"
              styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                    [class]="col.field === 'datalhe' ? 'text-center' : 'text-left'"
                    style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
                    [ngStyle]="{'width': col.width}">
                    {{col.header}}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-dadosUsadoNaTroca let-columns="columns">
                <tr>
                  <td *ngFor="let col of columns">
                    {{dadosUsadoNaTroca[col.field]}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-panel>
        <br>
        <p-panel header="Histórico" [toggleable]="true">
          <div class="row alinhamento-row">
            <div class="col-4">
              <small translate class="stats-label head-item"> Data/Hora do 1º Contato: </small>
              <h6 class="font-size-information">{{leadGrid.dtPrimeiroContato ? (leadGrid.dtPrimeiroContato | date: 'dd/MM/yyyy HH:mm') : '--'}}</h6>
            </div>
            <div class="col-4">
              <small translate class="stats-label head-item"> Qtde. Interações: </small>
              <h6 class="font-size-information">{{leadGrid.qtdeInteracoes != null ? leadGrid.qtdeInteracoes : '--'}}</h6>         
            </div>
          </div>
          <br>
          <div class="card">
            <p-table #dt [columns]="cols" [value]="dadosHistorico" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10,20,30,50,100]" [totalRecords]="dadosHistorico.totalRegistro"
              styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
              currentPageReportTemplate="{totalRecords} registro(s)">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                    [class]="col.field === 'datalhe' ? 'text-center' : 'text-left'"
                    style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
                    [ngStyle]="{'width': col.width}">
                    {{col.header}}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-dadosHistorico let-columns="columns">
                <tr>
                  <td *ngFor="let col of columns">
                    {{dadosHistorico[col.field]}}
                    <div style="display: flex; justify-content: center;">
                      <button pButton pRipple icon="pi pi-file" class="p-button-rounded p-button-info p-btn-sm p-mr-1"
                        pTooltip="Detalhes" *ngIf="col.field === 'datalhe'" (click)="abrirDetalhe(dadosHistorico)">
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-panel>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton label="Fechar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </ng-template>
</p-dialog>
<p-dialog header="Detalhe do Andamento" [(visible)]="displayBasic" [style]="{width: '50vw'}"
  (onHide)="fechar()" [baseZIndex]="10000">
  <div style="white-space: pre-wrap; word-wrap: break-word;">
    {{detalhe }}
  </div>
</p-dialog>